import { render } from "./SponsorSlider.vue?vue&type=template&id=0d451cdb"
import script from "./SponsorSlider.vue?vue&type=script&lang=js"
export * from "./SponsorSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__